/**
 * Copyright © 2026 Adnuntius AS.
 */
import {NavigationHistoryService} from './navigation-history.service';

function refFromNavigation(
  navigationHistory: NavigationHistoryService,
  $stateParams: any,
  objectKey: string,
  idKey?: string,
  nameKey?: string
): any {
  const previousObject = navigationHistory.previousParams[objectKey];
  if (previousObject) {
    return previousObject;
  }
  const resolvedIdKey = idKey || (objectKey + 'Id');
  const resolvedNameKey = nameKey || (objectKey + 'Name');
  const id = $stateParams[resolvedIdKey] || navigationHistory.previousParams[resolvedIdKey];
  const name = $stateParams[resolvedNameKey] || navigationHistory.previousParams[resolvedNameKey];
  if (id && name) {
    return {id, name};
  }
  if (id) {
    return {id};
  }
  return null;
}

export function advertiserFromNavigation(navigationHistory: NavigationHistoryService, $stateParams: any): any {
  return refFromNavigation(navigationHistory, $stateParams, 'advertiser');
}

export function lineItemFromNavigation(navigationHistory: NavigationHistoryService, $stateParams: any): any {
  return refFromNavigation(navigationHistory, $stateParams, 'lineItem');
}

export function creativeSetFromNavigation(navigationHistory: NavigationHistoryService, $stateParams: any): any {
  return refFromNavigation(navigationHistory, $stateParams, 'creativeSet');
}

export function folioFromNavigation(navigationHistory: NavigationHistoryService, $stateParams: any): any {
  return refFromNavigation(navigationHistory, $stateParams, 'folio');
}

export function advertiserNavigationParams(advertiser: any): any {
  return {
    advertiserId: advertiser.id,
    advertiserName: advertiser.name
  };
}
